export enum Entity {
    Normalizaciones = 1,
    Consolidaciones = 2,
    ComunidadesAutonomas = 3,
    Provincias = 4,
    Municipios = 5,
    VariacionesMunicipios = 6,
    TiposVía = 7,
    VariacionesTiposVía = 8,
    Tramero = 9,
    NombresPila = 10,
    VariacionesNombresPila = 11,
    Apellidos = 12,
    VariacionesApellidos = 13,
    Configuracion = 14,
    Usuarios = 15,
    Permisos = 16,
    NivelesPermisos = 17,
    Dashboard = 18,
    Datos = 19,
    IPS = 20,
    Clientes = 21,
    Notificaciones = 22,
    Extracciones = 23,
    Verticales = 24
}

export enum PermissionLevel {
    Ver = 1,
    Editar = 2,
    Eliminar = 3,
    Crear = 4,
    Administrar = 5,
    SuperAdministrar = 6
}

export class Permiso {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public userId: number | undefined;
    public nivelPermisoId: number | undefined;
    public entidadId: number | undefined;
}